/*
 *	Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .constant('UPLOAD_ITEM_STATUS', {
        NEW: 'uploadItemStatus.new',             // Newly created item
        AWAITING: 'uploadItemStatus.awaiting',   // Waiting for uploading
        UPLOADING: 'uploadItemStatus.uploading', // Items is uploading
        CONFLICT: 'uploadItemStatus.conflict',   // Items has conflict
        ERROR: 'uploadItemStatus.error',         // An error occurred on item upload
        CANCELLED: 'uploadItemStatus.cancelled', // Uploading has been canceled
        SUCCESS: 'uploadItemStatus.success'      // Successfully uploaded
    })
    .factory('UploadStat', ['UPLOAD_ITEM_STATUS', function (UPLOAD_ITEM_STATUS) {
        return function UploadStat() {
            var that = this;

            Object.getOwnPropertyNames(UPLOAD_ITEM_STATUS).forEach(function (statusName) {
                Object.defineProperty(that, UPLOAD_ITEM_STATUS[statusName], {
                    enumerable: true,
                    value: 0,
                    writable: true
                });

                // Create short-hand, read-only props for external usage
                Object.defineProperty(that, statusName.toLowerCase(), {
                    enumerable: false,
                    get: function () {
                        return this[UPLOAD_ITEM_STATUS[statusName]];
                    }
                });
            }, {});

            Object.defineProperty(that, 'add', {
                enumerable: false,
                /**
                 * Add statistics to the current one
                 * 
                 * @param {UploadStat} stat - Upload statistics to add
                 */
                value: function (stat) {
                    for (var statusName in stat) {
                        that[statusName] += stat[statusName];
                    }
                }
            });
        };
    }])
    .factory('UploadItem', [
        'UPLOAD_ITEM_STATUS',
        function (UPLOAD_ITEM_STATUS) {
            /**
             * Basic interface for uploading items
             * @constructor
             */
            function UploadItem() {
                Object.defineProperty(this, 'name', {
                    configurable: true,
                    enumerable: true,
                    get: function () {
                        throw new Error('must be implemented in child class');
                    }
                });

                Object.defineProperty(this, 'isDirectory', {
                    configurable: true,
                    enumerable: true,
                    get: function () {
                        throw new Error('must be implemented in child class');
                    }
                });

                Object.defineProperty(this, 'status', {
                    configurable: false,
                    enumerable: true,
                    value: UPLOAD_ITEM_STATUS.NEW,
                    writable: true
                });

                Object.defineProperty(this, 'isUploading', {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return this.status === UPLOAD_ITEM_STATUS.UPLOADING;
                    }
                });

                /**
                 * Upload success indicator
                 * 
                 * @type {boolean}
                 */
                Object.defineProperty(this, 'isSuccess', {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return this.status === UPLOAD_ITEM_STATUS.SUCCESS;
                    }
                });

                /**
                 * Upload cancel indicator
                 * 
                 * @type {boolean}
                 */
                Object.defineProperty(this, 'isCancel', {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return this.status === UPLOAD_ITEM_STATUS.CANCELLED;
                    }
                });

                /**
                 * Error instance
                 * 
                 * @type {(Error|null)}
                 */
                var _error = null;
                /**
                 * Upload error
                 * 
                 * @type {(Error|null)}
                 */
                Object.defineProperty(this, 'error', {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return _error;
                    },
                    set: function (error) {
                        this.status = UPLOAD_ITEM_STATUS.ERROR;
                        _error = error;
                    }
                });

                /**
                 * Boolean error flag
                 * 
                 * @type {boolean}
                 */
                Object.defineProperty(this, 'hasError', {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return this.status === UPLOAD_ITEM_STATUS.ERROR;
                    }
                });

                /**
                 * Uploading item has a conflict
                 * 
                 * @type {boolean}
                 */
                Object.defineProperty(this, 'hasConflict', {
                    configurable: false,
                    enumerable: true,
                    get: function () {
                        return this.status === UPLOAD_ITEM_STATUS.CONFLICT;
                    }
                });

                Object.defineProperty(this, 'upload', {
                    configurable: true,
                    enumerable: false,
                    value: function () {
                        throw new Error('must be implemented in child class');
                    }
                });

                Object.defineProperty(this, 'cancelUpload', {
                    configurable: true,
                    enumerable: false,
                    value: function () {
                        throw new Error('must be implemented in child class');
                    }
                });

                /**
                 * Force overwrite uploading item
                 * 
                 * @type {boolean}
                 */
                Object.defineProperty(this, 'overwrite', {
                    enumerable: true,
                    value: false,
                    writable: true
                });

                /**
                 * Upload progress
                 */
                Object.defineProperty(this, 'progress', {
                    enumerable: true,
                    value: {
                        bytes: 0,
                        percent: 0,
                        timeLeft: 0
                    },
                    writable: true
                });
            }

            return UploadItem;
        }
    ]);
